import React from 'react'
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core/styles'
import { withRouter } from 'react-router'

import { Button } from '@material-ui/core'

import 'leaflet/dist/leaflet.css'
import {
  Map,
  Marker,
  Popup,
  TileLayer,
} from 'react-leaflet'
import L from 'leaflet'

// TODO: Total hack, don't do this
L.Icon.Default.imagePath = 'https://unpkg.com/leaflet@1.3.1/dist/images/'
const OSAccessToken = 'pk.eyJ1IjoiamFzb25raW0iLCJhIjoiY2pjc2Exd3ZtMHRxeTJ4czBrYXFrd3VidSJ9.1TZpTmPeZcGxMfBeNYPFrw'

class CommunityMapView extends React.Component {
  static propTypes = {
    classes: PropTypes.object.isRequired,
    communities: PropTypes.object.isRequired,
    history: PropTypes.object.isRequired,
  }

  static styles = () => ({
    map: {
      height: '300px',
    },
  })

  onCommunityClick = (community) => {
    this.props.history.push(`/communities/${community.id}`)
  }

  marker = (community) => {
    if (community.location && community.location.latitude && community.location.longitude) {
      return (
        <Marker key={community.id} position={[community.location.latitude, community.location.longitude]}>
          <Popup>
            <Button onClick={() => { this.onCommunityClick(community) }}>{community.name}</Button>
          </Popup>
        </Marker>
      )
    }
    return null
  }

  coordinates() {
    const { communities } = this.props
    const coordinates = []
    Object.values(communities).forEach((community) => {
      if (community.location && community.location.latitude && community.location.longitude) {
        coordinates.push([community.location.latitude, community.location.longitude])
      }
    })

    if (coordinates.length === 0) {
      // show all of US
      coordinates.push([47.6062, -122.3321])
      coordinates.push([25.7617, -80.1918])
    }

    return coordinates
  }

  mapOptions() {
    const coordinates = this.coordinates()
    const options = {
      maxZoom: 22,
    }
    if (coordinates.length === 1) {
      [options.center] = coordinates
      options.zoom = 16
    } else {
      options.bounds = coordinates
    }
    return options
  }

  render() {
    const { classes, communities } = this.props

    if (Object.keys(communities).length > 0) {
      return (
        <Map className={classes.map} {...this.mapOptions()}>
          <TileLayer
            url="https://api.tiles.mapbox.com/v4/{id}/{z}/{x}/{y}.png?access_token={accessToken}"
            attribution="© <a href='https://www.mapbox.com/about/maps/'>Mapbox</a> © <a href='http://www.openstreetmap.org/copyright'>OpenStreetMap</a> <strong><a href='https://www.mapbox.com/map-feedback/' target='_blank'>Improve this map</a></strong>"
            id="mapbox.emerald"
            accessToken={OSAccessToken}
          />
          {Object.values(communities).map(this.marker)}
        </Map>
      )
    }

    return null
  }
}

export default withStyles(CommunityMapView.styles)(withRouter(CommunityMapView))
